import type { Middleware } from "redux";
import { actionTypes } from "@/store/cacheReducer";
import { LOCAL_STORAGE_KEYS } from "@/constants/storageKey";
import { ErrorType, reportErrorToSentry } from "@/utils/error";
import sentry, { WarningLevel } from "@/utils/sentry";

export const cacheMiddleware: Middleware = (store) => (next) => (action) => {
  // 1. 先交給下一個 middleware / reducer，讓 Redux state 正常更新
  const result = next(action);

  // 2. 再根據 action.type 判斷，要不要做額外處理
  if (action.type === actionTypes.SET_CACHE) {
    const state = store.getState();
    const cache = state.cache || {};

    // 觀察用，日後可移除
    const sizeMB = (JSON.stringify(cache).length / (1024 * 1024)).toFixed(4);

    // 這裡做副作用，同步到 localStorage
    try {
      localStorage.setItem(LOCAL_STORAGE_KEYS.appCache, JSON.stringify(cache));

      // 觀察用，日後可移除
      if (parseFloat(sizeMB) > 1) {
        sentry.reportWarning("App cache size exceeds 1MB", WarningLevel.WARNING, {
          cacheSizeMB: sizeMB,
        });
      }
    } catch (error) {
      console.error("Failed to save cache to localStorage:", error);
      const context = {
        cacheKey: action.payload?.key,
        cacheSizeMB: sizeMB,
      };
      reportErrorToSentry(error, context, ErrorType.RUNTIME_ERROR);
    }
  }

  return result;
};
